import { Box, Button, CircularProgress, Container, Grid, IconButton, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { Redirect } from 'react-router-dom';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

let aux = '';
let entradaIn = '';
let salidaIn = '';
let desc = '';
const opcionesFilasPorPagina = [5, 10, 25];
let filasTotales = 0;

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

class ControlAsistenciaNuevo extends Component {
    constructor(props){
        super(props);
        this.state = {
            compensarLlegadaTarde: false,
            compensarSAH: false,
            notificaciones: null,
            notificacionesDescuentos: null,
            errores: null,
            consulta: false,
            resCodEspecial: false,
            loading: false,
            numeroNombre: [],
            consultaRealizada: [],
            ubicacionesRelojes: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            tipoEncabezado: '',
            numerosFuncionariosConsulta: [],
            controlesFuncionario: [],

            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: '',
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },

            //--------------------
            hoveredCell: null,
            datoEspecifico: {},
            consultaEspecifica: false,
            hayDatos: false,
            tieneSolLt: false,
            tieneSolSAH: false,
            tieneSolDia: false,
            //--------------------
            descuentoMensual: [],
            horasInhabilesGeneradas: [],

            //------------------------
            isFieldsetOpen: true,
            isFieldsetOpenSolicitudes: false,
            informesAListar: [],
            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------
            horasEntradas: [],
            codigosEstadosInforme: [],
            codigosInforme: [],
            datoEspecificoConsulta: {},
            modalConsulta: false,
            nuevaSolicitud: false,
            agregarDescuento: {
                tipoDescuento: '',
                minutosDescuento: '',
                numeroFuncionario: '',
                nombreFuncionario: '',
                notasGenerales: '',
            },
            modalDescuentos: false,
            modalJustificar: false,
            modalNotificar: false,
        }

        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioControl = this.manejarEnvioControl.bind(this);
        this.manejarEnvioControlyDescuento = this.manejarEnvioControlyDescuento.bind(this);
        this.handleDateClick = this.handleDateClick.bind(this);
        this.manejarAtrasEspecifico = this.manejarAtrasEspecifico.bind(this);
        this.manejarConsulta = this.manejarConsulta.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarAgregarDescuento = this.manejarAgregarDescuento.bind(this);
        this.manejarCambiosDatosDescuento = this.manejarCambiosDatosDescuento.bind(this);
        this.manejarEnviarDesceunto = this.manejarEnviarDesceunto.bind(this);
        this.manejarVolverDesceunto = this.manejarVolverDesceunto.bind(this);
        this.manejarAgregarMinutosJustificados = this.manejarAgregarMinutosJustificados.bind(this);
        this.manejarEnviarMinutos = this.manejarEnviarMinutos.bind(this);
        this.manejarEnviarControlIndividual = this.manejarEnviarControlIndividual.bind(this);
        this.manejarEnvioControlyDescuentoIndividual = this.manejarEnvioControlyDescuentoIndividual.bind(this);
        this.cerrarModalNotificar = this.cerrarModalNotificar.bind(this);
    }

    

    async componentDidMount(){
        const fech = new Date();
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado['hastaBusqueda'] = fech.toISOString().substring(0,10);
            return{
                busqueda: numFunActualizado,
            };
        });
        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const datoReloj = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesRelojes.php`);
        const datosUbiRel = await datoReloj.json();
        this.setState({
            ubicacionesRelojes: datosUbiRel,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });

        const codEstadoInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosEstadosInforme.php`);
        const datosCodEstadoInfo = await codEstadoInfo.json();
        this.setState({
            codigosEstadosInforme: datosCodEstadoInfo,
        });

        const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosMovimientos.php`);
        const datosCodInfo = await codInfo.json();
        this.setState({
            codigosInforme: datosCodInfo,
        });
    }


    //-------------------
    handleMouseEnter = (index) => {
        this.setState({ hoveredCell: index });
    };
    
    handleMouseLeave = () => {
        this.setState({ hoveredCell: null });
    };

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };

    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.informesAListar.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };
    //-------------------
    render(){
        const { hoveredCell } = this.state;
        const { isFieldsetOpen } = this.state;
        const { isFieldsetOpenSolicitudes } = this.state;
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.informesAListar.length;

        return (
            <>
                {sessionStorage.login && sessionStorage.tipoUsuario === '4'
                ?
                    <Container>
                        <h3>Control de Asistencia</h3>
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        {this.state.notificacionesDescuentos ? (<div className="alert alert-success" > {this.state.notificacionesDescuentos}</div>) : null}
                        {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                        {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}

                        {this.state.consulta && (!this.state.consultaEspecifica)
                        ?
                                <ReactHtmlTableToExcel id="botonExportarExcel" className="btn btn-outline-success" table="tablaConsulta" filename="prueba" sheet="pagina 1" buttonText="Exportar a Excel">
                                </ReactHtmlTableToExcel>
                        :
                            null
                        }
                        {this.state.consulta && (!this.state.consultaEspecifica)
                        ?
                            <>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto', marginTop: '2rem'}} component={Paper} >
                                    <Table sx={{minWidth: 700}} id="tablaConsulta">
                                        {this.state.busqueda.codigo !== '1002' && this.state.busqueda.codigo !== '1001'
                                        ?
                                            <>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="center" colSpan={10} style={{display:"none"}}>
                                                            {this.state.tipoEncabezado}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableHead>
                                                    <TableRow>
                                                        <StyledTableCell align="center" colSpan={10}>
                                                            TARJETA:  {this.state.numerosFuncionariosConsulta[0].numeroFuncionario} {this.state.numerosFuncionariosConsulta[0].nombreFuncionario}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                </TableHead>
                                            </>
                                        :
                                            null
                                        }
                                        <TableHead>
                                            <TableRow>
                                                {this.state.busqueda.codigo === '1000' ? <StyledTableCell>Número</StyledTableCell> : null }
                                                {this.state.busqueda.codigo === '1000' ? <StyledTableCell>Nombre</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1000' ? <StyledTableCell>Fecha</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1000' ? <StyledTableCell>Hora</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>2</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell></StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>C101</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>C105</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>C102</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>C110</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>C137</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' || this.state.busqueda.codigo === '1001' ? null : <StyledTableCell>Ubicación</StyledTableCell>}
                                            </TableRow>
                                            <TableRow>
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell></StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Nombre</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Inasistencias con aviso</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Paro</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Descuentyos Entrada/Salida</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Inasistencias sin aviso</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1002' ? <StyledTableCell>Descanso Intermedio</StyledTableCell> : null}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {this.state.controlesFuncionario.map((cont, indexCont) => (
                                                this.state.busqueda.codigo === '1000'
                                                ?
                                                    <StyledTableRow key={indexCont}>
                                                        <StyledTableCell width={'20%'}>{cont.numeroFuncionario}</StyledTableCell>
                                                        <StyledTableCell>{cont.nombreFuncionario}</StyledTableCell>
                                                        <StyledTableCell>{cont.fecha}</StyledTableCell>
                                                        <StyledTableCell>{cont.hora}</StyledTableCell>
                                                        <StyledTableCell>{cont.ubicacion}</StyledTableCell>
                                                    </StyledTableRow>
                                                :
                                                    this.state.busqueda.codigo === '1001'
                                                    ?
                                                        <React.Fragment key={cont.numeroFuncionario}>
                                                            <TableRow key={indexCont} style={{backgroundColor: 'black'}}>
                                                                <StyledTableCell align="center" colSpan={10} style={{color:'white', fontWeight: 'bold'}}>TARJETA: {cont.numeroFuncionario} {cont.nombreFuncionario}</StyledTableCell>
                                                            </TableRow>
                                                            <TableRow key={indexCont+10000} style={{backgroundColor: 'black'}}>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Día</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Fecha</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Entra</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Sale</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Entra</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Sale</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Entra</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Sale</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Observaciones</StyledTableCell>
                                                                <StyledTableCell style={{color:'white', fontWeight: 'bold'}}>Ubicación</StyledTableCell>
                                                            </TableRow>
                                                            {cont.control.map((resu, indexResu) => (
                                                                resu.paraBotonesFinal && (this.state.busqueda.nombreFuncionarioBusqueda === '')
                                                                ?
                                                                    <StyledTableRow key={indexResu+cont.numeroFuncionario}>
                                                                        <StyledTableCell></StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                        <StyledTableCell colSpan={2} style={{alignItems: 'center', textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnviarControlIndividual(cont.control)}>Confirmar Control</button></StyledTableCell>
                                                                        <StyledTableCell colSpan={4} style={{alignItems: 'center', textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnvioControlyDescuentoIndividual(cont.control)}>Con. Control y Descuento</button></StyledTableCell>
                                                                        <StyledTableCell colSpan={4}></StyledTableCell>
                                                                    </StyledTableRow>
                                                                :
                                                                    resu.final
                                                                    ?
                                                                        <StyledTableRow key={indexResu+cont.numeroFuncionario}>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell colSpan={2} style={{alignItems: 'center', textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnviarControlIndividual(cont.control)}>Confirmar Control</button></StyledTableCell>
                                                                            <StyledTableCell colSpan={4} style={{alignItems: 'center', textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnvioControlyDescuentoIndividual(cont.control)}>Con. Control y Descuento</button></StyledTableCell>
                                                                            <StyledTableCell colSpan={4}></StyledTableCell>
                                                                        </StyledTableRow>
                                                                    :
                                                                        resu.resumen === ''
                                                                        ?
                                                                            <StyledTableRow key={indexResu+cont.numeroFuncionario}>
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.diaSemana}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.diaSemana}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.diaSemana}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.diaSemana}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'} className="clickable" onClick={() => this.handleDateClick(resu)} onMouseEnter={() => this.handleMouseEnter(indexResu+cont.numeroFuncionario)} onMouseLeave={this.handleMouseLeave} style={{backgroundColor: hoveredCell === indexResu+cont.numeroFuncionario ? '#fae1e1' : 'transparent', cursor: 'pointer',}}>{resu.fecha}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell width={'20%'} className="clickable" onClick={() => this.handleDateClick(resu)} onMouseEnter={() => this.handleMouseEnter(indexResu+cont.numeroFuncionario)} onMouseLeave={this.handleMouseLeave} style={{backgroundColor: hoveredCell === indexResu+cont.numeroFuncionario ? '#fae1e1' : 'transparent', cursor: 'pointer', color: 'green'}}>{resu.fecha}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'} className="clickable" onClick={() => this.handleDateClick(resu)} onMouseEnter={() => this.handleMouseEnter(indexResu+cont.numeroFuncionario)} onMouseLeave={this.handleMouseLeave} style={{backgroundColor: hoveredCell === indexResu+cont.numeroFuncionario ? '#fae1e1' : 'transparent', cursor: 'pointer',}}>{resu.fecha}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell width={'20%'} className="clickable" onClick={() => this.handleDateClick(resu)} onMouseEnter={() => this.handleMouseEnter(indexResu+cont.numeroFuncionario)} onMouseLeave={this.handleMouseLeave} style={{backgroundColor: hoveredCell === indexResu+cont.numeroFuncionario ? '#fae1e1' : 'transparent', cursor: 'pointer', color: 'red'}}>{resu.fecha}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca1}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca1}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca1}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca1}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca2}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca2}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca2}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca2}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca3}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca3}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca3}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca3}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca4}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca4}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca4}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca4}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca5}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca5}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca5}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca5}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.marca6}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.marca6}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.marca6}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca6}</StyledTableCell>
                                                                                }
                                                                                {/*(resu.cantMarcas === 4) || (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO') ? <StyledTableCell width={'20%'}>{resu.marca2}</StyledTableCell> : <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca2}</StyledTableCell>}
                                                                                {(resu.cantMarcas === 4) || (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO') ? <StyledTableCell width={'20%'}>{resu.marca3}</StyledTableCell> : <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca3}</StyledTableCell>}
                                                                                {(resu.cantMarcas === 4) || (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO') ? <StyledTableCell width={'20%'}>{resu.marca4}</StyledTableCell> : <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca4}</StyledTableCell>}
                                                                                {(resu.cantMarcas === 4) || (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO') ? <StyledTableCell width={'20%'}>{resu.marca5}</StyledTableCell> : <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca5}</StyledTableCell>}
                                                                                {(resu.cantMarcas === 4) || (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO') ? <StyledTableCell width={'20%'}>{resu.marca6}</StyledTableCell> : <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.marca6}</StyledTableCell>*/}
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.observaciones}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.observaciones}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.observaciones}</StyledTableCell>
                                                                                        :
                                                                                            (resu.masDe6Marcas)
                                                                                            ?
                                                                                                <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.observaciones} Tiene mas de 6 Marcas</StyledTableCell>
                                                                                            :
                                                                                                <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.observaciones}</StyledTableCell>
                                                                                }
                                                                                {(resu.cantMarcas === 4)
                                                                                ?
                                                                                    <StyledTableCell width={'20%'}>{resu.ubicacion}</StyledTableCell>
                                                                                :
                                                                                    (resu.diaSemana == 'SABADO') || (resu.diaSemana == 'DOMINGO')
                                                                                    ?
                                                                                        <StyledTableCell style={{color: 'green'}} width={'20%'}>{resu.ubicacion}</StyledTableCell>
                                                                                    :
                                                                                        (resu.escalafon === 1) && ((resu.cargaHoraria === 48) || (resu.cargaHoraria === 40)) && (resu.cantMarcas === 2)
                                                                                        ?
                                                                                            <StyledTableCell width={'20%'}>{resu.ubicacion}</StyledTableCell>
                                                                                        :
                                                                                            <StyledTableCell style={{color: 'red'}} width={'20%'}>{resu.ubicacion}</StyledTableCell>
                                                                                }
                                                                            </StyledTableRow>
                                                                        :
                                                                            <StyledTableRow key={indexResu+cont.numeroFuncionario}>
                                                                                <StyledTableCell colSpan={10}>{resu.resumen}</StyledTableCell>
                                                                            </StyledTableRow>
                                                            ))}
                                                        </React.Fragment>
                                                    :
                                                        this.state.busqueda.codigo === '1002'
                                                        ?
                                                            <StyledTableRow key={indexCont}>
                                                                <StyledTableCell>{cont.numeroFuncionario}</StyledTableCell>
                                                                <StyledTableCell>{cont.nombreFuncionario}</StyledTableCell>
                                                                <StyledTableCell>{cont.cod101}</StyledTableCell>
                                                                <StyledTableCell>{cont.cod105}</StyledTableCell>
                                                                <StyledTableCell>{cont.cod102}</StyledTableCell>
                                                                <StyledTableCell>{cont.cod104}</StyledTableCell>
                                                                <StyledTableCell>{cont.cod137}</StyledTableCell>
                                                            </StyledTableRow>
                                                        :
                                                            null
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {this.state.consulta ? <button className="btn btn-outline-success mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null }
                                {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioControl}>Confirmar Control</button> : null }
                                {this.state.consulta ? <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioControlyDescuento}>Confirmar Control y Descuento</button> : null }
                                {this.state.consulta ? <br/>: null}
                                <br/>
                            </>
                        :
                            null
                        }
                        {this.state.consulta
                        ?
                            null
                        :
                            <>
                                <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                                    <Table sx={{minWidth: 700}}>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Consulta</StyledTableCell>
                                                {this.state.busqueda.codigo !== '1002' ? <StyledTableCell>Número Funcionario</StyledTableCell> : null}
                                                {this.state.busqueda.codigo !== '1002' ? <StyledTableCell>Nombre</StyledTableCell> : null}
                                                {this.state.busqueda.codigo !== '1002' ? <StyledTableCell>Ubicación</StyledTableCell> : null}
                                                {this.state.busqueda.ubicacionBusqueda === '0' ? <StyledTableCell width={'16%'}>Ubicación Central</StyledTableCell> : null}
                                                {this.state.busqueda.codigo === '1001' ? <StyledTableCell>Mes</StyledTableCell> : this.state.busqueda.codigo === '1002' ? <StyledTableCell>Mes</StyledTableCell> : <StyledTableCell>Desde</StyledTableCell>}
                                                {this.state.busqueda.codigo === '1001' ? <StyledTableCell>Año</StyledTableCell> : this.state.busqueda.codigo === '1002' ? <StyledTableCell>Año</StyledTableCell> : <StyledTableCell>Hasta</StyledTableCell>}
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            <StyledTableRow>
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.busqueda.codigo} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>CONSULTA</option>
                                                        <option value={1000} key={1000}>MARCAS FUNCIONARIOS</option>
                                                        <option value={1001} key={1001}>CONTROL MENSUAL</option>
                                                        <option value={1002} key={1002}>DESCUENTOS PARA LIQUIDACIONES</option>
                                                    </select>
                                                </StyledTableCell>
                                                {this.state.busqueda.codigo !== '1002' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                                {this.state.busqueda.codigo !== '1002' ? <StyledTableCell>{this.state.busqueda.nombreFuncionarioBusqueda}</StyledTableCell> : null}
                                                {this.state.busqueda.codigo !== '1002'
                                                ?
                                                    <StyledTableCell>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionBusqueda'  value={this.state.busqueda.ubicacionBusqueda} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>UBICACION</option>
                                                            {this.state.lugaresTra.map((name) =>
                                                                <option
                                                                key={name.idLugaresTrabajo}
                                                                value={name.idLugaresTrabajo}
                                                                >{name.lugar}</option>
                                                                )}
                                                        </select>
                                                    </StyledTableCell>
                                                :
                                                    null
                                                }
                                                {this.state.busqueda.ubicacionBusqueda === '0' ?
                                                    <StyledTableCell>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                            <option value=''>UBICACION</option>
                                                            {this.state.ubicacionesCentral.map((name) =>
                                                                <option
                                                                key={name.idUbicacionesCentral}
                                                                value={name.idUbicacionesCentral}
                                                                >{name.descripcion}
                                                            </option>
                                                                )}
                                                        </select>
                                                    </StyledTableCell> : null
                                                }
                                                {this.state.busqueda.codigo === '1001' || this.state.busqueda.codigo === '1002' ? <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.busqueda.mes} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>MES</option>
                                                        <option value={'01'}>ENERO</option>
                                                        <option value={'02'}>FEBRERO</option>
                                                        <option value={'03'}>MARZO</option>
                                                        <option value={'04'}>ABRIL</option>
                                                        <option value={'05'}>MAYO</option>
                                                        <option value={'06'}>JUNIO</option>
                                                        <option value={'07'}>JULIO</option>
                                                        <option value={'08'}>AGOSTO</option>
                                                        <option value={'09'}>SETIEMBRE</option>
                                                        <option value={'10'}>OCTUBRE</option>
                                                        <option value={'11'}>NOVIEMBRE</option>
                                                        <option value={'12'}>DICIEMBRE</option>
                                                    </select>
                                                </StyledTableCell> : null}
                                                { this.state.busqueda.codigo === '1001' || this.state.busqueda.codigo === '1002' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="text" id='anio' value={this.state.busqueda.anio} onChange={this.manejarCambiosDatos}/></StyledTableCell> : <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>}
                                                { this.state.busqueda.codigo === '1001' || this.state.busqueda.codigo === '1002' ? null : <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hastaBusqueda' value={this.state.busqueda.hastaBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>}
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <br/>
                            </>
                        }
                        {this.state.consultaEspecifica
                        ?
                            <>
                                <h3>RESUMEN DÍA: {this.state.datoEspecifico.fecha}</h3>
                                {this.state.datoEspecifico.marca1} {this.state.datoEspecifico.marca2} {this.state.datoEspecifico.marca3} {this.state.datoEspecifico.marca4} {this.state.datoEspecifico.marca5} {this.state.datoEspecifico.marca6}<br/>
                                {/*this.state.datoEspecifico.observaciones*/}
                                {this.state.datoEspecifico.minutosTardes > 0
                                ?
                                    <>
                                        <p>Tiene {this.state.datoEspecifico.minutosTardes} minutos de llegada tarde</p>
                                    </>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.minutosSalidaAntes > 0
                                ?
                                    <>
                                        <p>Tiene {this.state.datoEspecifico.minutosSalidaAntes} minutos de salida antes de hora</p>
                                    </>
                                :
                                    null
                                }
                                <>
                                    {this.state.modalJustificar
                                    ?
                                        null
                                    :
                                        <p style={{color: 'red'}}>Esto se debe usar cuando el programa no calcula por si solo los descuentos</p>
                                    }
                                    {!this.state.modalDescuentos && (!this.state.modalJustificar)
                                    ?
                                        <>
                                            <p>Agregar minutos Llegada Tarde/Salida antes de Hora</p>
                                            <button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarAgregarDescuento(this.state.datoEspecifico)}>Agregar Minutos</button>
                                            <p style={{marginTop: '2rem'}}>Justificar Llegada Tarde/Salida antes de Hora</p>
                                            <button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarAgregarMinutosJustificados(this.state.datoEspecifico)}>Justificar Minutos</button>
                                        </>
                                    :
                                        null
                                    }
                                </>
                                {/*this.state.mesActual ? <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarNuevaSolicitud}>Nueva Solicitud</button> : null*/}
                                {this.state.nuevaSolicitud
                                ?
                                    <>

                                    </>
                                :
                                    null
                                }
                                {this.state.compensarLlegadaTarde
                                ?
                                    <TableContainer style={{width: '75%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                        <Table sx={{minWidth: 700}} id="tablaConsulta">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{textAlign: 'center'}}>Concepto</StyledTableCell>
                                                    <StyledTableCell style={{textAlign: 'center'}}>Tipo</StyledTableCell>
                                                    {this.state.datosAEnviar.codigo === '40' ? <StyledTableCell style={{textAlign: 'center'}}>Días</StyledTableCell> : <StyledTableCell style={{textAlign: 'center'}}>Minutos</StyledTableCell>}
                                                    <StyledTableCell></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <StyledTableRow>
                                                    <StyledTableCell>
                                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='codigo'  value={this.state.datosAEnviar.codigo} onChange={this.manejarCambioAEnviar}>
                                                            <option value=''></option>
                                                            <option value={46}>HORAS SIMPLES</option>
                                                            <option value={28}>HORAS INHÁBILES</option>
                                                            {this.state.datosAEnviar.tipo === 0 ? <option value={40}>ACTA 1694</option> : null}
                                                        </select>
                                                    </StyledTableCell>
                                                    {this.state.datosAEnviar.tipo === 0 ? <StyledTableCell style={{textAlign: 'center'}}>DIA COMPLETO</StyledTableCell> : null}
                                                    {this.state.datosAEnviar.tipo === 1 ? <StyledTableCell style={{textAlign: 'center'}}>LLEGADA TARDE</StyledTableCell> : null}
                                                    {this.state.datosAEnviar.tipo === 2 ? <StyledTableCell style={{textAlign: 'center'}}>SALIDA ANTES DE HORA</StyledTableCell> : null}
                                                    {this.state.datosAEnviar.codigo === '40' ? <StyledTableCell style={{textAlign: 'center'}}><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='dias' value={this.state.datosAEnviar.dias} onChange={this.manejarCambioAEnviar} type="number" /></StyledTableCell> : <StyledTableCell style={{textAlign: 'center'}}><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='minutos' value={this.state.datosAEnviar.minutos} onChange={this.manejarCambioAEnviar} type="number" /></StyledTableCell>}
                                                    <StyledTableCell style={{textAlign: 'center'}}><button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioInforme}>Enviar</button></StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                    null
                                }
                                {!this.state.modalConsulta && (!this.state.modalDescuentos) && (!this.state.modalJustificar)
                                ?
                                    <fieldset>
                                        <legend onClick={this.toggleFieldset} className="clickable">
                                            {/*isFieldsetOpen ? 'Ocultar Información' : 'Mostrar Información'*/}
                                        </legend>
                                        {isFieldsetOpen && (
                                            <div className="fieldset-content">
                                                {this.state.hayDatos
                                                ?
                                                    <Container>
                                                        <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                            <Table sx={{minWidth: 700}} id="tablaConsulta">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <StyledTableCell>Informe</StyledTableCell>
                                                                        <StyledTableCell>Número</StyledTableCell>
                                                                        <StyledTableCell>Nombre</StyledTableCell>
                                                                        <StyledTableCell>Estado</StyledTableCell>
                                                                        <StyledTableCell>Desde</StyledTableCell>
                                                                        <StyledTableCell>Hasta</StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                        <StyledTableCell></StyledTableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {this.state.informesAListar.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                                                        <StyledTableRow key={name.idInformes}>
                                                                            {this.state.codigosInforme.map((name2) => {
                                                                                if(name2.idCodigoMovimiento === name.codigo){
                                                                                    desc = name2.descripcion;
                                                                                }
                                                                            })}
                                                                            <StyledTableCell>{desc}</StyledTableCell>
                                                                            <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                                            <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                                            {desc = ''}
                                                                            {this.state.codigosEstadosInforme.map((name3) => {
                                                                                if(name3.idCodigosEstadoInformes === name.finalizado){
                                                                                    desc = name3.descripcion;
                                                                                }
                                                                            })}
                                                                            <StyledTableCell>{desc}</StyledTableCell>
                                                                            <StyledTableCell>{name.desde.substring(8,10) + '/' + name.desde.substring(5,7) + '/' + name.desde.substring(0,4)}</StyledTableCell>
                                                                            {name.hasta === null ? <StyledTableCell></StyledTableCell> : <StyledTableCell>{name.hasta.substring(8,10) + '/' + name.hasta.substring(5,7) + '/' + name.hasta.substring(0,4)}</StyledTableCell>}
                                                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarConsulta(name)}>Consultar</button></StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                        </StyledTableRow>
                                                                    ))
                                                                    }
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                        <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                                                    </Container>
                                                :
                                                    <p>No hay datos para mostrar!</p>
                                                }
                                            </div>
                                        )}
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarAtrasEspecifico}>Volver</button>
                                    </fieldset>
                                :
                                    <>
                                        {this.state.modalConsulta
                                        ?
                                            <Container>
                                                <h3>Informes</h3>
                                                <Box sx={{ flexGrow: 1}}>
                                                    <Grid container spacing={2} rowSpacing={1}>
                                                        {this.state.codigosInforme.map((name2) => {
                                                            if(name2.idCodigoMovimiento === this.state.datoEspecificoConsulta.codigo){
                                                                desc = name2.descripcion;
                                                            }
                                                        })}
                                                        <Grid item xs={4}>
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                            {desc}
                                                        </Grid>
                                                        <Grid item xs={4}>
                                                        </Grid>
                                                        {/*Esto va siempre */}
                                                        <Grid item xs={2}>
                                                        </Grid>
                                                        {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 44 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 66
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Certificado (Imagen)</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 10
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Constancia de Domicilio</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 75
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Comprobante (Imagen)</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 66 || this.state.datoEspecificoConsulta.codigo === 21
                                                        ?
                                                            this.state.datoEspecificoConsulta.esPDF
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                </Grid>
                                                            :
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 44 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 56 || this.state.datoEspecificoConsulta.codigo === 66
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 75
                                                        ?
                                                            this.state.datoEspecificoConsulta.esPDF
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                </Grid>
                                                            :
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Certificado De Parentesco (Imagen)</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 11
                                                        ?
                                                            this.state.datoEspecificoConsulta.esPDF
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoActa)}>Descargar</button>
                                                                </Grid>
                                                            :
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoActa)}>Ver</button>
                                                                </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Familiar</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13 || this.state.datoEspecificoConsulta.codigo === 4
                                                        ?
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.familiar}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 4 || this.state.datoEspecificoConsulta.codigo === 42 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 4|| this.state.datoEspecificoConsulta.codigo === 42
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 60
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>{this.state.datoEspecificoConsulta.codigo === 43 || this.state.datoEspecificoConsulta.codigo === 19 || this.state.datoEspecificoConsulta.codigo === 10 || this.state.datoEspecificoConsulta.codigo === 21 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 62 || this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 75
                                                        ?
                                                            <Grid item xs={2}>
                                                                {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 61
                                                        ?
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.marca1}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 30
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 56
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 3 || this.state.datoEspecificoConsulta.codigo === 22 || this.state.datoEspecificoConsulta.codigo === 51 || this.state.datoEspecificoConsulta.codigo === 23 || this.state.datoEspecificoConsulta.codigo === 48 || this.state.datoEspecificoConsulta.codigo === 11 || this.state.datoEspecificoConsulta.codigo === 47 || this.state.datoEspecificoConsulta.codigo === 66 || this.state.datoEspecificoConsulta.codigo === 12 || this.state.datoEspecificoConsulta.codigo === 13
                                                        ?
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Hasta</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                        ?
                                                            <Grid item xs={2}>
                                                                {String(this.state.datoEspecificoConsulta.hasta).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.hasta).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.hasta).substring(0,4)}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 61
                                                        ?
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.marca2}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 37
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 61
                                                        ?
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 60
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Día</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 60
                                                        ?
                                                            <Grid item xs={2}>
                                                                {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 80 || this.state.datoEspecificoConsulta.codigo === 71 || this.state.datoEspecificoConsulta.codigo === 1 || this.state.datoEspecificoConsulta.codigo === 67 || this.state.datoEspecificoConsulta.codigo === 40 || this.state.datoEspecificoConsulta.codigo === 16 || this.state.datoEspecificoConsulta.codigo === 17 || this.state.datoEspecificoConsulta.codigo === 29 || this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52 || this.state.datoEspecificoConsulta.codigo === 14 || this.state.datoEspecificoConsulta.codigo === 15 || this.state.datoEspecificoConsulta.codigo === 20
                                                        ?
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 66
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Días</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 66
                                                        ?  
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.dias}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 80) || (this.state.datoEspecificoConsulta.codigo === 71) || (this.state.datoEspecificoConsulta.codigo === 1) || (this.state.datoEspecificoConsulta.codigo === 67) || (this.state.datoEspecificoConsulta.codigo === 2) || (this.state.datoEspecificoConsulta.codigo === 37) || (this.state.datoEspecificoConsulta.codigo === 40) || (this.state.datoEspecificoConsulta.codigo === 35) || (this.state.datoEspecificoConsulta.codigo === 56) || (this.state.datoEspecificoConsulta.codigo === 14) || (this.state.datoEspecificoConsulta.codigo === 15) || (this.state.datoEspecificoConsulta.codigo === 16) || (this.state.datoEspecificoConsulta.codigo === 17) || (this.state.datoEspecificoConsulta.codigo === 20)
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecificoConsulta.entrada === name.idEntrada){
                                                                entradaIn = name.descripcion;
                                                        }})}
                                                        {this.state.horasEntradas.map((name) => {
                                                            if(this.state.datoEspecificoConsulta.salida === name.idEntrada){
                                                                salidaIn = name.descripcion;
                                                        }})}
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Entrada</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={2}>
                                                                {entradaIn}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={1}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Salida</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={2}>
                                                                {salidaIn}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 71
                                                        ?
                                                            <Grid item xs={1}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 71 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 14 && this.state.datoEspecificoConsulta.codigo !== 16 && this.state.datoEspecificoConsulta.codigo !== 17 && this.state.datoEspecificoConsulta.codigo !== 15 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 29 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 37 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 51 && this.state.datoEspecificoConsulta.codigo !== 22 && this.state.datoEspecificoConsulta.codigo !== 23 && this.state.datoEspecificoConsulta.codigo !== 20 && this.state.datoEspecificoConsulta.codigo !== 57 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 35 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 107 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 108 && this.state.datoEspecificoConsulta.codigo !== 5 && this.state.datoEspecificoConsulta.codigo !== 52 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 48 && this.state.datoEspecificoConsulta.codigo !== 56 && this.state.datoEspecificoConsulta.codigo !== 66
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Ejercicio (AÑO)</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo !== 53 && this.state.datoEspecificoConsulta.codigo !== 30 && this.state.datoEspecificoConsulta.codigo !== 60 && this.state.datoEspecificoConsulta.codigo !== 3 && this.state.datoEspecificoConsulta.codigo !== 75 && this.state.datoEspecificoConsulta.codigo !== 62 && this.state.datoEspecificoConsulta.codigo !== 74 && this.state.datoEspecificoConsulta.codigo !== 71 && this.state.datoEspecificoConsulta.codigo !== 61 && this.state.datoEspecificoConsulta.codigo !== 14 && this.state.datoEspecificoConsulta.codigo !== 16 && this.state.datoEspecificoConsulta.codigo !== 17 && this.state.datoEspecificoConsulta.codigo !== 15 && this.state.datoEspecificoConsulta.codigo !== 4 && this.state.datoEspecificoConsulta.codigo !== 29 && this.state.datoEspecificoConsulta.codigo !== 46 && this.state.datoEspecificoConsulta.codigo !== 28 && this.state.datoEspecificoConsulta.codigo !== 42 && this.state.datoEspecificoConsulta.codigo !== 43 && this.state.datoEspecificoConsulta.codigo !== 37 && this.state.datoEspecificoConsulta.codigo !== 19 && this.state.datoEspecificoConsulta.codigo !== 10 && this.state.datoEspecificoConsulta.codigo !== 21 && this.state.datoEspecificoConsulta.codigo !== 44 && this.state.datoEspecificoConsulta.codigo !== 51 && this.state.datoEspecificoConsulta.codigo !== 22 && this.state.datoEspecificoConsulta.codigo !== 23 && this.state.datoEspecificoConsulta.codigo !== 20 && this.state.datoEspecificoConsulta.codigo !== 57 && this.state.datoEspecificoConsulta.codigo !== 11 && this.state.datoEspecificoConsulta.codigo !== 12 && this.state.datoEspecificoConsulta.codigo !== 13 && this.state.datoEspecificoConsulta.codigo !== 35 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 107 && this.state.datoEspecificoConsulta.codigo !== 109 && this.state.datoEspecificoConsulta.codigo !== 108 && this.state.datoEspecificoConsulta.codigo !== 5 && this.state.datoEspecificoConsulta.codigo !== 52 && this.state.datoEspecificoConsulta.codigo !== 110 && this.state.datoEspecificoConsulta.codigo !== 47 && this.state.datoEspecificoConsulta.codigo !== 48 && this.state.datoEspecificoConsulta.codigo !== 56 && this.state.datoEspecificoConsulta.codigo !== 66
                                                        ?  
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.anio}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 2 && this.state.datoEspecificoConsulta.codigo !== 106 && this.state.datoEspecificoConsulta.codigo !== 109
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46 || this.state.datoEspecificoConsulta.codigo === 110
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Minutos</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                        ?  
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.minutos}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Juzgado</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 10
                                                        ?
                                                            <Grid item xs={2}>
                                                                    
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                        ?
                                                            <Grid item xs={1}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Asignatura</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52)
                                                        ?
                                                            <Grid item xs={1}>
                                                                {this.state.datoEspecificoConsulta.juzgado}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Comprobante</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 14))
                                                        ?
                                                            this.state.datoEspecificoConsulta.esPDF
                                                            ?
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecificoConsulta.archivoBPS)}>Descargar</button>
                                                                </Grid>
                                                            :
                                                                <Grid item xs={2}>
                                                                    <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecificoConsulta.archivoBPS)}>Ver</button>
                                                                </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 5 || this.state.datoEspecificoConsulta.codigo === 52) && ((this.state.datoEspecificoConsulta.finalizado === 12) || (this.state.datoEspecificoConsulta.finalizado === 13) || (this.state.datoEspecificoConsulta.finalizado === 14) || (this.state.datoEspecificoConsulta.finalizado === 18))
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 10
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Nueva Dirección</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 10
                                                        ?  
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.juzgado}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {(this.state.datoEspecificoConsulta.codigo === 30) || (this.state.datoEspecificoConsulta.codigo === 60) || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37
                                                        ?
                                                            <Grid item xs={2}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 62
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Tipo Omisión</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 62
                                                        ?
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.tipo}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                        ?    
                                                            <Grid item xs={2}>
                                                                <Item>Tipo Salida</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 30 || this.state.datoEspecificoConsulta.codigo === 60 || this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46 || this.state.datoEspecificoConsulta.codigo === 37
                                                        ?  
                                                            <Grid item xs={2}>
                                                                {this.state.datoEspecificoConsulta.tipo}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 37
                                                        ?  
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 35 || this.state.datoEspecificoConsulta.codigo === 28 || this.state.datoEspecificoConsulta.codigo === 46
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?    
                                                            <Grid item xs={2.1}>
                                                                <Item>Entrada</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?    
                                                            <Grid item xs={2.1}>
                                                                <Item>Salilda</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?    
                                                            <Grid item xs={2.1}>
                                                                <Item>Entrada</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 109
                                                        ?
                                                            <Grid item xs={2.1}>
                                                                <Item>Concepto</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 109
                                                        ?
                                                            <Grid item xs={2.1}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?    
                                                            <Grid item xs={2.1}>
                                                                <Item>Salilda</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106
                                                        ?  
                                                            <Grid item xs={2}>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 106 || this.state.datoEspecificoConsulta.codigo === 109
                                                        ?  
                                                            <Grid item xs={1}>
                                                                
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 110
                                                        ?
                                                            <Grid item xs={2}>
                                                                <Item>Día</Item>
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 110
                                                        ?
                                                            <Grid item xs={2}>
                                                                {String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}
                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 110
                                                        ?
                                                            <Grid item xs={1}>

                                                            </Grid>
                                                        :
                                                            null
                                                        }
                                                        {this.state.datoEspecificoConsulta.codigo === 74
                                                        ?
                                                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                                                <Table sx={{minWidth: 700}}>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <StyledTableCell>Lunes</StyledTableCell>
                                                                            <StyledTableCell>Martes</StyledTableCell>
                                                                            <StyledTableCell>Miercoles</StyledTableCell>
                                                                            <StyledTableCell>Jueves</StyledTableCell>
                                                                            <StyledTableCell>Viernes</StyledTableCell>
                                                                            <StyledTableCell>Sábado</StyledTableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        <StyledTableRow>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaLunes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaMartes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaMiercoles === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaJueves === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaViernes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.entradaSabado === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                        </StyledTableRow>
                                                                        <StyledTableRow>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaLunes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaMartes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaMiercoles === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaJueves === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaViernes === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                            {this.state.horasEntradas.map((name) => {
                                                                                if(this.state.datoEspecificoConsulta.salidaSabado === name.idEntrada){
                                                                                    entradaIn = name.descripcion;
                                                                            }})}
                                                                            <StyledTableCell>{entradaIn}</StyledTableCell>
                                                                        </StyledTableRow>
                                                                        <StyledTableRow>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell>Desde</StyledTableCell>
                                                                            <StyledTableCell>{String(this.state.datoEspecificoConsulta.desde).substring(8,10) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(5,7) + '/' + String(this.state.datoEspecificoConsulta.desde).substring(0,4)}</StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                            <StyledTableCell></StyledTableCell>
                                                                        </StyledTableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                        :
                                                            null
                                                        }
                                                    </Grid>
                                                </Box>
                                                <br/>
                                                {this.state.datoEspecificoConsulta.codigo === 110 || this.state.datoEspecificoConsulta.codigo === 61 || this.state.datoEspecificoConsulta.codigo === 37 || this.state.datoEspecificoConsulta.codigo === 77 || this.state.datoEspecificoConsulta.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='comentarios' value={this.state.datoEspecificoConsulta.comentarios} disabled/> : null}
                                                {this.state.datoEspecificoConsulta.motivoRechazo !== null && this.state.datoEspecificoConsulta.motivoRechazo !== '' ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={10} cols={40} id='motivoRechazo' value={this.state.datoEspecificoConsulta.motivoRechazo} disabled/> : null}
                                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Volver</button>
                                            </Container>

                                        :
                                            null
                                        }
                                    </>
                                }
                                {this.state.modalDescuentos
                                ?
                                    <>
                                        <Box sx={{ flexGrow: 1}} style={{marginTop: '1rem'}}>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Item>Tipo de descuento</Item>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoDescuento'  value={this.state.agregarDescuento.tipoDescuento} onChange={this.manejarCambiosDatosDescuento}>
                                                        <option value=''></option>
                                                        <option value={1} key={1}>LLEGADA TARDE</option>
                                                        <option value={2} key={2}>SALIDA ANTES DE HORA</option>
                                                    </select>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Item>Minutos</Item>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutosDescuento' value={this.state.agregarDescuento.minutosDescuento} onChange={this.manejarCambiosDatosDescuento}/>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnviarDesceunto()}>Guardar</button>
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarVolverDesceunto}>Volver</button>
                                    </>
                                :
                                    null
                                }
                                {this.state.modalJustificar
                                ?
                                    <>
                                        <Box sx={{ flexGrow: 1}} style={{marginTop: '1rem'}}>
                                            <Grid container spacing={2} rowSpacing={1}>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Item>Tipo de tiempo justificado</Item>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='tipoDescuento'  value={this.state.agregarDescuento.tipoDescuento} onChange={this.manejarCambiosDatosDescuento}>
                                                        <option value=''></option>
                                                        <option value={1} key={1}>LLEGADA TARDE</option>
                                                        <option value={2} key={2}>SALIDA ANTES DE HORA</option>
                                                        <option value={3} key={3}>MEDIA HORA DE DESCANSO</option>
                                                    </select>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Item>Minutos</Item>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='minutosDescuento' value={this.state.agregarDescuento.minutosDescuento} onChange={this.manejarCambiosDatosDescuento}/>
                                                </Grid>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={2}>
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Item>Motivo</Item>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                        <Container>
                                        <textarea style={{width:"75%", border:"2px solid #D6EAF8", marginTop: '1rem', marginLeft: '9rem'}} rows={5} cols={50} id='notasGenerales' value={this.state.agregarDescuento.notasGenerales} onChange={this.manejarCambiosDatosDescuento}/>
                                        </Container>
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarEnviarMinutos()}>Guardar</button>
                                        <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarVolverDesceunto}>Volver</button>
                                    </>
                                :
                                    null
                                }
                            </>
                        :
                            null
                        }
                    </Container>
                :
                    <Redirect to='/login'/>
                }
                <Modal open={this.state.modalNotificar}>
                    <form className='formulario1'>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={12}>
                                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                                </Grid>
                                <Grid item xs={4.5}>

                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModalNotificar}>Aceptar</button>
                                </Grid>
                                <Grid item xs={5}>

                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            loading: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if((clave === 'numeroFuncionarioBusqueda') && (valor !== '') ){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionarioBusqueda'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionarioBusqueda'] = '';
                }
                });
            }else if((clave === 'nombreFuncionarioBusqueda') && (valor === '')){
                numFunActualizado['nombreFuncionarioBusqueda'] = '';
            }
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalConsulta: false,
            datoEspecificoConsulta: {},
            notificacionesDescuentos: null,
            errores: null,
            notificaciones: null,
        })
    }

    manejarAtrasEspecifico(e){
        e.preventDefault();
        this.setState({
            datoEspecifico: {},
            consultaEspecifica: false,
            nuevaSolicitud: false,
            hayDatos: false,
            informesAListar: [],
            tieneSolLt: false,
            tieneSolSAH: false,
            tieneSolDia: false,
            notificaciones: null,
            errores: null,
            notificacionesDescuentos: null,
        })
    }

    async manejoEnvioConsulta(){

        if(this.state.busqueda.codigo === ''){
            this.setState({
                errores: 'DEBE SELECCIONAR UNA CONSULTA!',
            });
        }else if((this.state.busqueda.codigo !== '1002') && (this.state.busqueda.codigo !== '1001') && (this.state.busqueda.desdeBusqueda === '')){
            this.setState({
                errores: 'DEBE INGRESAR LA FECHA DESDE!',
            });
        }else if((this.state.busqueda.numeroFuncionarioBusqueda !== '') && (this.state.busqueda.nombreFuncionarioBusqueda === '')){
            this.setState({
                errores: 'DEBE INGRESAR UN NUMERO DE FUNCIONARIO VALIDO!',
            });
        }else if((this.state.busqueda.numeroFuncionarioBusqueda === '') && (this.state.busqueda.ubicacionBusqueda === '') && (this.state.busqueda.codigo !== '1002')){
            this.setState({
                errores: 'DEBE INGRESAR EL NUMERO DE FUNCIONARIO Y/O LA UBICACION!',
            });
        }else if(((this.state.busqueda.codigo === '1001') || (this.state.busqueda.codigo === '1002')) && (this.state.busqueda.mes === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL MES!',
            });
        }else if(((this.state.busqueda.codigo === '1001') || (this.state.busqueda.codigo === '1002')) && (this.state.busqueda.anio === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO!',
            });
        }else{
            this.setState({
                errores: null,
                notificaciones: null,
                loading: true,
            });

            
            const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/control_asistencia.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            let num = '';
            this.setState({
                loading: false,
            })
            if(exito[0].length !== 0){
                this.setState({
                    consultaRealizada: exito[0],
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                    numerosFuncionariosConsulta: exito[1],
                    descuentoMensual: exito[2],
                    horasInhabilesGeneradas: exito[3],
                    controlesFuncionario: this.state.busqueda.codigo === '1001' ? exito[4] : this.state.busqueda.codigo === '1002' || this.state.busqueda.codigo === '1000' ? exito[0] : [],
                    loading: false,
                    //-----------------------------------
                    modalDescuentos: false,
                    modalJustificar: false,
                    datoEspecificoConsulta: {},
                    errores: null,
                    notificaciones: null,
                    agregarDescuento: {
                        tipoDescuento: '',
                        minutosDescuento: '',
                        numeroFuncionario: '',
                        nombreFuncionario: '',
                        notasGenerales: '',
                    },
                    consultaEspecifica: false,
                    datoEspecifico: {},
                    //----------------------------------
                });

                if((this.state.busqueda.codigo === '1000') && (this.state.busqueda.numeroFuncionarioBusqueda !== '') && (this.state.busqueda.ubicacionBusqueda === '')){
                    this.setState({
                        tipoEncabezado: 'LISTADO DE MARCAS FUNCIONARIO ' + this.state.busqueda.numeroFuncionarioBusqueda,
                    });
                }
            }else{
                const fech = new Date();
                this.setState({
                    loading: false,
                    consultaRealizada: [],
                    errores: 'No hay datos para la consulta realizada!',
                    notificaciones: null,
                    consulta: false,
                    busqueda: {
                        codigo: '',
                        numeroFuncionarioBusqueda: '',
                        nombreFuncionarioBusqueda: '',
                        desdeBusqueda: '',
                        hastaBusqueda: fech.toISOString().substring(0,10),
                        ubicacionBusqueda: '',
                        ubicacionCentral: '',
                        mes: '',
                        loading: false,
                        anio: '',
                    },
                });
            }
        }
    }

    manejarAtras(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },
        });
    }

    async manejarEnvioControl(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.consultaRealizada, this.state.horasInhabilesGeneradas, false]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/confirmarControlAsistencia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            loading: false,
        })
        if(exito === 'ok'){
            this.setState({
                loading: false,
                errores: null,
                notificaciones: 'Los datos fueron ingresados correctamente!',
            })
        }
    }

    async manejarEnvioControlyDescuento(e){
        e.preventDefault();
        const fech = new Date();
        this.setState({
            consulta: false,
            consultaRealizada: [],
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },
            loading: true,
        })

        const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.consultaRealizada, this.state.horasInhabilesGeneradas, false]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/confirmarControlAsistencia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            loading: false,
        })

        const cargaUtil2 = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.descuentoMensual, false]);
        const respuesta2 = await fetch(`${Constantes.RUTA_API}/confirmar_descuentoMensual.php`,{
            method: 'POST',
            body: cargaUtil2,
        })
        const exito2 = await respuesta2.json();
        this.setState({
            errores: exito2,
            loading: false,
        })
        
        if((exito === 'ok') && (exito2 === 'ok')){
            this.setState({
                loading: false,
                errores: null,
                notificaciones: 'Los datos fueron ingresados correctamente!',
            })
        }
    }

    async handleDateClick(dato) {
        // Redirigir a una nueva ventana con la URL deseada
        //window.open(`/details?date=${date}`, '_blank');
        this.setState({
            consultaEspecifica: true,
            datoEspecifico: dato,
            loading: true,
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
        })
        //Consulto la info de ese día
        const cargaUtil = JSON.stringify([dato]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_obtenerAccionesDia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
        })
        if(exito[0] === 'ok'){
            this.setState({
                informesAListar: exito[1],
                hayDatos: true,
                tieneSolLt: exito[2],
                tieneSolSAH: exito[3],
                tieneSolDia: exito[4],
            })
        }
    };

    manejarConsulta(dato){
        this.setState({
            modalConsulta: true,
            datoEspecificoConsulta: dato,
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
        })
    }

    manejarAgregarDescuento(dato){
        this.setState({
            modalDescuentos: true,
            modalJustificar: false,
            datoEspecificoConsulta: dato,
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
        })
    }

    manejarCambiosDatosDescuento(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            loading: false,
        });
        this.setState(state => {
            const numFunActualizado = state.agregarDescuento;
            numFunActualizado[clave] = valor;
            return{
                agregarDescuento: numFunActualizado,
            };
        });
    }

    async manejarEnviarDesceunto(){
        this.setState({
            errores: null,
            loading: true,
        })
        //----------------------------Me fijo si tengo descuentos para ingresar----------------------------------
        const cargaUtil = JSON.stringify([this.state.datoEspecificoConsulta, this.state.agregarDescuento, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_descuentosETSAH.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            errores: exito[0],
        })
        //----------------------------Me fijo si tengo descuentos para ingresar----------------------------------
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificacionesDescuentos: 'Datos ingresados correctamente',
            })
            this.manejoEnvioConsulta();
        }
    }

    manejarVolverDesceunto(e){
        e.preventDefault();
        this.setState({
            modalDescuentos: false,
            modalJustificar: false,
            datoEspecifico: {},
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
        })
    }

    manejarAgregarMinutosJustificados(dato){
        this.setState({
            modalDescuentos: false,
            modalJustificar: true,
            datoEspecificoConsulta: dato,
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
        })
    }

    async manejarEnviarMinutos(){
        this.setState({
            errores: null,
            loading: true,
        })
        //----------------------------Me fijo si tengo descuentos para ingresar----------------------------------
        const cargaUtil = JSON.stringify([this.state.datoEspecificoConsulta, this.state.agregarDescuento, sessionStorage.numeroFuncionarioAsociado]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_minutosJustificados.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            loading: false,
            errores: exito[0],
        })
        //----------------------------Me fijo si tengo descuentos para ingresar----------------------------------
        if(exito[0] === 'ok'){
            this.setState({
                errores: null,
                notificacionesDescuentos: 'Datos ingresados correctamente',
            })
            this.manejoEnvioConsulta();
        }
    }

    async manejarEnviarControlIndividual(dato){
        const fech = new Date();
        this.setState({
            //consulta: false,
            //consultaRealizada: [],
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            /*busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },*/
            loading: true,
        })
        const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, dato, this.state.horasInhabilesGeneradas, true]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/confirmarControlAsistencia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            loading: false,
        })
        if(exito === 'ok'){
            this.setState({
                loading: false,
                errores: null,
                modalNotificar: true,
                notificaciones: 'Los datos fueron ingresados correctamente!',
            })
        }
    }

    async manejarEnvioControlyDescuentoIndividual(dato){
        const fech = new Date();
        this.setState({
            //consulta: false,
            //consultaRealizada: [],
            errores: null,
            notificaciones: null,
            notificacionesDescuentos: null,
            /*busqueda: {
                codigo: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                desdeBusqueda: '',
                hastaBusqueda: fech.toISOString().substring(0,10),
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                mes: '',
                anio: '',
            },*/
            loading: true,
        })

        const cargaUtil = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, dato, this.state.horasInhabilesGeneradas, true]);
        const respuesta = await fetch(`${Constantes.RUTA_API}/confirmarControlAsistencia.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();
        this.setState({
            errores: exito,
            loading: false,
        })

        const cargaUtil2 = JSON.stringify([this.state.busqueda, sessionStorage.numeroFuncionario, sessionStorage.numeroFuncionarioAsociado, this.state.descuentoMensual, true, dato]);
        const respuesta2 = await fetch(`${Constantes.RUTA_API}/confirmar_descuentoMensual.php`,{
            method: 'POST',
            body: cargaUtil2,
        })
        const exito2 = await respuesta2.json();
        this.setState({
            errores: exito2,
            loading: false,
        })
        
        if((exito === 'ok') && (exito2 === 'ok')){
            this.setState({
                loading: false,
                errores: null,
                modalNotificar: true,
                notificaciones: 'Los datos fueron ingresados correctamente!',
            })
        }
    }

    cerrarModalNotificar(e){
        e.preventDefault();
        this.setState({
            notificaciones: null,
            errores: null,
            notificacionesDescuentos: null,
            modalNotificar: false,
        })
    }
}

export default ControlAsistenciaNuevo